import _ from "lodash";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { uomDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { standardProposalRequiredFieldList } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NbisDateTimePickerComponent from "presentation/view/components/NbisDateTimePickerComponent";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHCheckbox, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const AdditionalChargeEditPanel: React.FC = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const { additionalState } = counterCustomerChargeState;
    const { isAdd, isEditable, editingEntity, allFormState } = additionalState;
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;

    const memoSubChgTypeOptions = useMemo(() => {
        const groupOfSubChgTypeOptions = editingEntity.chargeType ? counterCustomerChargeState.dynamicOptions.subChgTypeByUserDropdownOptions[editingEntity.chargeType] : [];
        const commonSubChgTypeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonSubChgTypeOptions;
    }, [counterCustomerChargeState.dynamicOptions.subChgTypeByUserDropdownOptions, editingEntity.chargeType]);

    const memoTariffCodeOptions = useMemo(() => {
        return editingEntity.tariffType
            ? counterCustomerChargeState.dynamicOptions.tariffCodeDropdownOptions[editingEntity.tariffType]
            : [];
    }, [counterCustomerChargeState.dynamicOptions.tariffCodeDropdownOptions, editingEntity.tariffType]);

    const isDisableOptional = useMemo(() => {
        return _.isEmpty(editingEntity?.cntrNo)
    }, [editingEntity?.cntrNo]);

    const isDay = useMemo(() => {
        return editingEntity?.chargeQtyUom !== 'DAY'
    }, [editingEntity?.chargeQtyUom]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        counterCustomerChargeVM.onFieldChange(fieldName, fieldValue);
    }, [counterCustomerChargeVM]);

    const handleSaveClick = useCallback(async () => {
        setIsLoading(true);
        counterCustomerChargeVM.onSaveAdditionalClicked();
        counterCustomerChargeVM.onSaveAdditionalEdit(editingEntity).then(async res => {
            if (res && res.success) {
                /*let searchCriteria = {
                    ...EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA,
                };
                searchCriteria = {
                    ...searchCriteria,
                    billOfLadingNo: editingEntity.billOfLading,
                    shippingBill: editingEntity.shippingBill
                }
                await counterCustomerChargeVM.searchAdditionalByCriteria(searchCriteria);*/
                // await counterCustomerChargeVM.onSearchAdditional(ids);
                setIsLoading(false);
                messageBarVM.showSuccess('Save Successfully.');
                //counterCustomerChargeVM.onAdditionalEditClose();
            } else if (res) {
                setIsLoading(false);
                res.data && messageBarVM.showError(res.data);
            } else if (allFormState?.message && allFormState.message !== '') {
                setIsLoading(false);
                messageBarVM.showError(allFormState.message);
            } else {
                setIsLoading(false);
                messageBarVM.showSuccess('Save Successfully.');
            }
        }).catch(() => {
            setIsLoading(false);
            messageBarVM.showError('Save Failed.');
        });

    }, [counterCustomerChargeVM, editingEntity, messageBarVM, allFormState]);

    const handClose = useCallback(() => {
        counterCustomerChargeVM.onAdditionalEditClose();
    }, [counterCustomerChargeVM]);

    const memoChgType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={editingEntity?.chargeType || ''}
                fieldValue={editingEntity?.chargeType}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.CHARGE_TYPE}
                isSaveClicked={additionalState.isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                maxLength={60}
                options={counterCustomerChargeState.dynamicOptions.chgTypeByUserDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, COUNTER_CUSTOMER_CHARGE_CONSTANT.CHARGE_TYPE, editingEntity?.chargeType, additionalState.isSaveClicked, counterCustomerChargeState.dynamicOptions.chgTypeByUserDropdownOptions, counterCustomerChargeVM])

    const memoSubChgType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={editingEntity?.subChargeType || ''}
                fieldValue={editingEntity?.subChargeType}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={additionalState.isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeType'}
                maxLength={60}
                options={memoSubChgTypeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.SUB_CHARGE_TYPE, editingEntity?.subChargeType, additionalState.isSaveClicked, memoSubChgTypeOptions, counterCustomerChargeVM])

    const memoQty = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NumberInputComponent
                label={COUNTER_CUSTOMER_CHARGE_CONSTANT.QTY}
                maxLength={10}
                decimalPlaces={2}
                //width="280px"
                fieldName={"chargeQty"}
                value={editingEntity?.chargeQty ?? ''}
                errorMessage={allFormState?.chargeQty}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.QTY, allFormState?.chargeQty, editingEntity?.chargeQty, onNumberFieldChange])

    const memoUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={editingEntity?.chargeQtyUom || ''}
                fieldValue={editingEntity?.chargeQtyUom}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.UOM}
                isSaveClicked={additionalState.isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeQtyUom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, COUNTER_CUSTOMER_CHARGE_CONSTANT.UOM, editingEntity?.chargeQtyUom, additionalState.isSaveClicked, counterCustomerChargeVM])

    const memoCntrNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={editingEntity?.cntrNo || ''}
                fieldValue={editingEntity?.cntrNo}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.CONTAINER_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cntrNo'}
                maxLength={12}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.CONTAINER_NO, editingEntity?.cntrNo, counterCustomerChargeVM])

    const memoSize = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={isDisableOptional}
                readOnlyValue={editingEntity?.cntrSize || ''}
                fieldValue={editingEntity?.cntrSize}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.SIZE}
                isSaveClicked={additionalState.isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrSize'}
                maxLength={60}
                options={counterCustomerChargeState.dynamicOptions.cntrSizeDropdownOptions}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isDisableOptional, editingEntity?.cntrSize, COUNTER_CUSTOMER_CHARGE_CONSTANT.SIZE, additionalState.isSaveClicked, counterCustomerChargeState.dynamicOptions.cntrSizeDropdownOptions, counterCustomerChargeVM])

    const memoType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={isDisableOptional}
                readOnlyValue={editingEntity?.cntrType || ''}
                fieldValue={editingEntity?.cntrType}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.TYPE}
                isSaveClicked={additionalState.isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrType'}
                maxLength={60}
                options={counterCustomerChargeState.dynamicOptions.cntrTypeDropdownOptions}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, COUNTER_CUSTOMER_CHARGE_CONSTANT.TYPE, editingEntity?.cntrType, additionalState.isSaveClicked, counterCustomerChargeState.dynamicOptions.cntrTypeDropdownOptions, counterCustomerChargeVM, isDisableOptional])

    const memoStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={isDisableOptional}
                readOnlyValue={editingEntity?.cntrStatus1 || ''}
                fieldValue={editingEntity?.cntrStatus1}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.STATUS}
                isSaveClicked={additionalState.isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrStatus1'}
                maxLength={60}
                options={counterCustomerChargeState.dynamicOptions.statusDropdownOptions}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, COUNTER_CUSTOMER_CHARGE_CONSTANT.STATUS, editingEntity?.cntrStatus1, additionalState.isSaveClicked, counterCustomerChargeState.dynamicOptions.statusDropdownOptions, counterCustomerChargeVM, isDisableOptional])

    const memoTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={editingEntity?.tariffType || ''}
                fieldValue={editingEntity?.tariffType}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.TARIFF_TYPE}
                isSaveClicked={additionalState.isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffType'}
                maxLength={60}
                options={counterCustomerChargeState.dynamicOptions.tariffTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, COUNTER_CUSTOMER_CHARGE_CONSTANT.TARIFF_TYPE, editingEntity?.tariffType, additionalState.isSaveClicked, counterCustomerChargeState.dynamicOptions.tariffTypeDropdownOptions, counterCustomerChargeVM])

    const memoTariffCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={editingEntity?.tariffCode || ''}
                fieldValue={editingEntity?.tariffCode}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.TARIFF_CODE}
                isSaveClicked={additionalState.isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffCode'}
                maxLength={60}
                options={memoTariffCodeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onAdditionalFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, COUNTER_CUSTOMER_CHARGE_CONSTANT.TARIFF_CODE, editingEntity?.tariffCode, additionalState.isSaveClicked, memoTariffCodeOptions, counterCustomerChargeVM])

    const memoFromDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <DatePickerComponent
                disabled={false}
                optional={isDay}
                label={COUNTER_CUSTOMER_CHARGE_CONSTANT.FROM}
                width="240px"
                date={editingEntity?.fromDate}
                fieldName="fromDate"
                errorMessage={allFormState ? allFormState["fromDate"] : ""}
                onDateChange={counterCustomerChargeVM.onAdditionalFieldChange} />
        </div>
        , [isDay, COUNTER_CUSTOMER_CHARGE_CONSTANT.FROM, editingEntity?.fromDate, allFormState, counterCustomerChargeVM.onAdditionalFieldChange])

    const memoToDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <DatePickerComponent
                disabled={false}
                optional={isDay}
                label={COUNTER_CUSTOMER_CHARGE_CONSTANT.TO}
                width="240px"
                date={editingEntity?.toDate}
                fieldName="toDate"
                errorMessage={allFormState ? allFormState["toDate"] : ""}
                onDateChange={counterCustomerChargeVM.onAdditionalFieldChange} />
        </div>
        , [isDay, COUNTER_CUSTOMER_CHARGE_CONSTANT.TO, editingEntity?.toDate, allFormState, counterCustomerChargeVM.onAdditionalFieldChange])

    const memoGateInDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <DatePickerComponent
                disabled={false}
                optional={true}
                label={COUNTER_CUSTOMER_CHARGE_CONSTANT.GATE_IN_DATE}
                width="240px"
                date={editingEntity?.gateInDate}
                fieldName="gateInDate"
                errorMessage={""}
                onDateChange={counterCustomerChargeVM.onAdditionalFieldChange} />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.GATE_IN_DATE, editingEntity?.gateInDate, counterCustomerChargeVM.onAdditionalFieldChange])

    const memoPcPlugOnDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisDateTimePickerComponent
                disabled={false}
                optional={true}
                label={COUNTER_CUSTOMER_CHARGE_CONSTANT.POWER_PLUG_ON_DATE}
                width="240px"
                date={editingEntity?.pcPlugOnDatetime}
                fieldName="pcPlugOnDatetime"
                errorMessage={""}
                onDateChange={counterCustomerChargeVM.onAdditionalFieldChange} />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.POWER_PLUG_ON_DATE, editingEntity?.pcPlugOnDatetime, counterCustomerChargeVM.onAdditionalFieldChange])

    const memoPcPlugOffDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisDateTimePickerComponent
                disabled={false}
                optional={true}
                label={COUNTER_CUSTOMER_CHARGE_CONSTANT.POWER_PLUG_OFF_DATE}
                width="240px"
                date={editingEntity?.pcPlugOffDatetime}
                fieldName="pcPlugOffDatetime"
                errorMessage={""}
                onDateChange={counterCustomerChargeVM.onAdditionalFieldChange} />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.POWER_PLUG_OFF_DATE, editingEntity?.pcPlugOffDatetime, counterCustomerChargeVM.onAdditionalFieldChange])

    const memoDgSurchargeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                fieldKey={"dgSurchargeInd"}
                requiredFieldList={[]}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.DG_SURCHARGE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={editingEntity?.dgSurchargeInd === 'Y'}
                disabled={false}
                onChange={(e) => counterCustomerChargeVM.onCheckboxChange(e.checked, "dgSurchargeInd")}
            />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.DG_SURCHARGE_IND, editingEntity?.dgSurchargeInd, counterCustomerChargeVM])

    const memoOogSurchargeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "240px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                fieldKey={"oogSurchargeInd"}
                requiredFieldList={[]}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.OOG_SURCHARGE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={editingEntity?.oogSurchargeInd === 'Y'}
                disabled={false}
                onChange={(e) => counterCustomerChargeVM.onCheckboxChange(e.checked, "oogSurchargeInd")}
            />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.OOG_SURCHARGE_IND, editingEntity?.oogSurchargeInd, counterCustomerChargeVM])

    return <>
        <div className='side-form-content-wrapper' style={{ height: `calc(100vh - ${operatingUnit === 'OICT' || operatingUnit === 'HPJZ' ? 440 : 350}px)` }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{'Additional Charge'}</SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '40vh', maxHeight: '40vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoChgType}
                            {memoSubChgType}
                            {memoCntrNo}
                            {memoQty}
                            {memoUom}
                            {memoSize}
                            {memoType}
                            {memoStatus}
                            {memoTariffType}
                            {memoTariffCode}
                            {memoFromDate}
                            {memoToDate}
                            {memoPcPlugOnDate}
                            {memoPcPlugOffDate}
                            {memoGateInDate}
                            {(operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && memoDgSurchargeInd}
                            {(operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && memoOogSurchargeInd}
                        </CriteriaItemContainer>
                    </div>
                    {additionalState.forceRefresh && <></>}
                </div>
            </div>

            <div className='im-charge-data-search-criteria-buttons'>
                {
                    <>
                        <HPHButton label={'Cancel'} size={'Small'} theme={'Secondary'} onClick={handClose} />
                        {<HPHButton label={isAdd ? 'Add' : isEditable ? 'Update' : 'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />}
                    </>
                }
            </div>
        </div>
    </>;
}

export default memo(AdditionalChargeEditPanel);
